'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAINNET_SERVER_URL = 'https://sai-mainnet.makerfoundation.com/v1';
var KOVAN_SERVER_URL = 'https://sai-kovan.makerfoundation.com/v1';

var QueryApi = function () {
  function QueryApi(network) {
    (0, _classCallCheck3.default)(this, QueryApi);

    switch (network) {
      case 'mainnet':
      case 1:
        this.serverUrl = MAINNET_SERVER_URL;
        break;
      case 'kovan':
      case 42:
        this.serverUrl = KOVAN_SERVER_URL;
        break;
      default:
        throw new Error('don\'t know what to do for network "' + network + '"');
    }
  }

  (0, _createClass3.default)(QueryApi, [{
    key: 'getCdpIdsForOwner',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(address) {
        var query, resp, _ref2, data;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = 'query ($lad: String) {\n      allCups(condition: { lad: $lad }) {\n        nodes {\n          id\n        }\n      }\n    }';
                _context.next = 3;
                return (0, _isomorphicFetch2.default)(this.serverUrl, {
                  method: 'POST',
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                  },
                  body: (0, _stringify2.default)({ query: query, variables: { lad: address } })
                });

              case 3:
                resp = _context.sent;
                _context.next = 6;
                return resp.json();

              case 6:
                _ref2 = _context.sent;
                data = _ref2.data;
                return _context.abrupt('return', data.allCups.nodes.map(function (n) {
                  return n.id;
                }));

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCdpIdsForOwner(_x) {
        return _ref.apply(this, arguments);
      }

      return getCdpIdsForOwner;
    }()
  }]);
  return QueryApi;
}();

exports.default = QueryApi;